import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { SSH_Buttons } from "../../../../../components/molecules/Buttons/Buttons.component";
import { SSH_ImageViewer } from "../../../../../components/molecules/ImageViewer/ImageViewer.component";
import { useBackgroundColor } from "../../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../../hooks/usePadding/usePadding.hook";
import Form from "./components/Form/Form.component";
import { V1Props } from "./TextFormV1.interface";
import { usePosition } from "./hooks/usePosition.hook";
import { useBackgroundCoverImage } from "./hooks/useBackgroundCoverImage";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./TextFormV1.module.scss";

export const V1 = (props: V1Props) => {
    const hasAnyTextContent =
        props.image || props.tagline || props.headline || props.text || props.buttons?.[0]
            ? true
            : false;

    const { backgroundColorClass, alternativeButtonTheme, hasBackgroundColor } = useBackgroundColor(
        props.backgroundColor
    );
    const { backgroundCoverImage } = useBackgroundCoverImage(
        props.backgroundCover,
        hasAnyTextContent
    );
    const { positionClass } = usePosition(props.position, S);
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);

    return (
        <div className={cn(S.wrapper, paddingClass, backgroundColorClass, positionClass)}>
            <DA_Container noVerticalPadding>
                {/** Content */}

                <div className={S.innerWrapper}>
                    {/** Background cover image */}
                    {backgroundCoverImage ? (
                        <SSH_ImageViewer
                            className={S.coverImage}
                            src={backgroundCoverImage}
                            aspectRatioX={16}
                            aspectRatioY={9}
                        />
                    ) : null}

                    {hasAnyTextContent ? (
                        <div className={cn(S.textWrapper, hasAnyTextContent && S.halfWidth)}>
                            {/** Image */}
                            {props.image ? (
                                <SSH_ImageViewer
                                    className={S.image}
                                    src={props.image.url}
                                    aspectRatioX={props.image.width}
                                    aspectRatioY={props.image.height}
                                />
                            ) : null}

                            {/** Tagline */}
                            {props.tagline ? (
                                <span className={S.tagline}>{props.tagline}</span>
                            ) : null}

                            {/** Title */}
                            {props.headline ? (
                                <DA_Title h2 tag={DA_TitleTag.H2} noMargin fullWidth>
                                    {props.headline}
                                </DA_Title>
                            ) : null}

                            {/** Text */}
                            {props.text ? (
                                <div className={S.text}>
                                    <DA_Text html={props.text} noPadding />
                                </div>
                            ) : null}

                            {/** Buttons */}
                            {props.buttons ? (
                                <SSH_Buttons
                                    buttons={props.buttons}
                                    theme={alternativeButtonTheme}
                                />
                            ) : null}
                        </div>
                    ) : null}

                    {/** Form */}
                    {props.form?.formData?.allFieldSets ? (
                        <div
                            className={cn(
                                S.formWrapper,
                                hasAnyTextContent && !props.position && S.positionFormRight
                            )}
                        >
                            {props.form?.formData?.allFieldSets && <Form {...props.form} />}
                        </div>
                    ) : null}
                </div>
            </DA_Container>
        </div>
    );
};

export default V1;
